module.exports = __webpack_public_path__ + "static/media/Female Samurai.7df956c9.jpg";